(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/base-addons/assets/javascripts/base-addons.js') >= 0) return;  svs.modules.push('/components/tipsen/base-addons/assets/javascripts/base-addons.js');
"use strict";


const _svs$ui = svs.ui,
  ReactPaper = _svs$ui.ReactPaper,
  ReactIcon = _svs$ui.ReactIcon;
const DialogContextual = svs.components.tipsen.DialogContextual;
const useBranding = svs.components.tipsen.hooks.useBranding;
const BaseAddons = _ref => {
  let children = _ref.children,
    className = _ref.className,
    description = _ref.description,
    icon = _ref.icon,
    id = _ref.id,
    title = _ref.title;
  const classNames = ["tipsen-addition ".concat(id)].concat(className !== null && className !== void 0 ? className : []);
  const branding = useBranding();
  const iconClassNames = ['tipsen-addition-icon'];
  if (branding.length > 1) {
    iconClassNames.push(branding[branding.length - 1]);
  }
  return React.createElement(ReactPaper, {
    branding: "sport",
    className: classNames.join(' ')
  }, React.createElement("article", {
    "aria-labelledby": "tipsen-addition-title-".concat(id),
    className: "tipsen-addition-grid"
  }, React.createElement("div", {
    className: "tipsen-addition-header"
  }, React.createElement(ReactIcon, {
    className: iconClassNames.join(' '),
    color: "fc-white",
    icon: icon
  }), React.createElement("h3", {
    className: "margin-right tipsen-addition-title",
    id: "tipsen-addition-title-".concat(id)
  }, title)), description && React.createElement("p", {
    className: "tipsen-addition-desc"
  }, description), children));
};
setGlobal('svs.components.tipsen.baseAddons.BaseAddons', BaseAddons);

 })(window);